import {Button, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import {GREEN_NAV, GREY_BACKGROUND_HOVER} from '../../../theme';

const styles = {
  cancelButton: {
    '&:hover': {
      backgroundColor: GREY_BACKGROUND_HOVER,
      borderRadius: '0.5rem',
      borderWidth: 0,
    },
    borderWidth: 0,
    height: '2.25rem',
    paddingHorizontal: '1rem',
    paddingVertical: '0.6825rem',
  },
  cancelButtonLabel: {
    color: GREEN_NAV,
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '130%',
  },
};

export const CancelButton = (props) => {
  const {isIngestionComplete, isProcessing, onClick} = props;

  if (isProcessing && !isIngestionComplete) {
    return null;
  }

  return (
    <Button onClick={onClick} sx={styles.cancelButton} variant="outlined">
      <Typography style={styles.cancelButtonLabel}>Cancel</Typography>
    </Button>
  );
};

CancelButton.propTypes = {
  isIngestionComplete: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
